// Caleums bespoke enquiry: keeps the "Continue on WhatsApp" links prefilled with a summary of the answers,
// sets the earliest selectable date to today, and after a successful submit restores the summary into the
// "Send photos on WhatsApp" link. The form itself works without this script (native Shopify contact form).
(() => {
  const KEY = 'caleums-bespoke-summary';
  const store = {
    get() { try { return sessionStorage.getItem(KEY); } catch { return null; } },
    set(v) { try { sessionStorage.setItem(KEY, v); } catch {} },
  };

  const init = (form) => {
    if (form.dataset.caleumsBespokeReady) return;
    form.dataset.caleumsBespokeReady = '1';
    let i18n = {};
    try { i18n = JSON.parse(form.querySelector('[data-caleums-bespoke-i18n]')?.textContent || '{}'); } catch {}
    const base = i18n.base || 'https://wa.me/971557576923';
    const links = form.querySelectorAll('[data-caleums-bespoke-wa]');

    const summary = () => {
      const lines = [i18n.intro || ''];
      // Document order, so the summary follows the form.
      form.querySelectorAll('[data-wa], [data-wa-group]').forEach((el) => {
        if (el.dataset.waGroup) {
          const picked = [...el.querySelectorAll('input:checked')].map((i) => i.dataset.waOption).filter(Boolean);
          if (picked.length) lines.push(`${el.dataset.waGroup}: ${picked.join(', ')}`);
          return;
        }
        let value = el.value.trim();
        if (!value) return;
        if (el.tagName === 'SELECT') value = el.options[el.selectedIndex]?.text.trim() || value;
        if (el.tagName === 'TEXTAREA') value = value.replace(/\s+/g, ' ').slice(0, 600);
        lines.push(`${el.dataset.wa}: ${value}`);
      });
      lines.push(i18n.photos || '');
      return lines.filter(Boolean).join('\n');
    };

    const setLinks = (text) => links.forEach((a) => { a.href = `${base}?text=${encodeURIComponent(text)}`; });
    const update = () => setLinks(summary());

    const date = form.querySelector('[data-caleums-bespoke-date]');
    if (date) {
      const d = new Date();
      date.min = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    const success = form.querySelector('[data-caleums-bespoke-success]');
    if (success) {
      const saved = store.get();
      if (saved) setLinks(saved);
      success.focus();
      success.scrollIntoView({ block: 'center' });
    }

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', () => store.set(summary()));
  };

  const run = () => document.querySelectorAll('form.caleums-bespoke__form').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
